(function () {
	const PREFIX_RE = /^\s*[A-Za-z0-9]+-\s*/;
	const trim = (t) => (t ? t.replace(PREFIX_RE, '').trim() : t);

	function update(btn) {
		if (!btn) return;
		const raw = (btn.textContent || '').trim();
		if (!raw || raw.toLowerCase() === 'select') return; // keep placeholder
		const trimmed = trim(raw);
		if (trimmed !== raw) btn.textContent = trimmed;
	}

	function attach(dropdown) {
		if (dropdown.dataset._trimAttached) return;
		dropdown.dataset._trimAttached = '1';

		const btn = dropdown.querySelector('button.dropdown-toggle');
		if (!btn) return;

		// MutationObserver trims as soon as Clay changes button text → no flash
		new MutationObserver(() => update(btn)).observe(btn, {
			childList: true,
			subtree: true,
			characterData: true
		});

		// Initial run
		update(btn);
	}

	function init() {
		document.querySelectorAll('.dropdown').forEach(attach);
	}

	// Watch for dropdowns added later
	new MutationObserver(init).observe(document.body, {
		childList: true,
		subtree: true
	});

	document.readyState === 'loading'
		? document.addEventListener('DOMContentLoaded', init)
		: init();
})();
